<template>
    <!-- 军事/公安类升学(民航招飞，海军招飞，空军招飞，军校招生，公安院校，航海类院校) -->
    <!-- 海军招飞 -->
    <div class="sea_force studyway_common_father">
        <div class="banner">
            <img src="/imgs/wayToStudy/main/banner.png" alt="">
        </div>
        <div class="main">
            <h6 class="main_title">关于海军飞行员</h6>
            <div class="main_box">
                <p>海军招收飞行学员工作，在教育部、公安部、财政部、总政治部统一部署和领导下进行，该四部负责制定、颁发招收飞行学员的政策、规定、计划，指导和协助处理招收飞行学员工作中的事宜。海军招收飞行学员工作机构和有关省、自治区、直辖市的教育、招生、公安部门负责组织实施。海军招飞工作全过程大约需要10个月时间。一般分为宣传动员、组织报名、初检预选、全面检测、定选录取几个阶段。</p>
            </div>    
        </div>
        <div class="application_condition main">
            <h6 class="main_title">报考条件有哪些？</h6>
            <div class="main_box">
                <p><span>自然条件</span>：考生为高中毕业男生(应届、往届均可)，具有海军开招地区学校学籍和开招省市户籍，文理科不限，年龄16—19周岁。</p>
                <p><span>政治条件</span>：考生必须热爱祖国、热爱中国共产党;思想进步、忠诚老实，品德优良，遵纪守法、历史清白、现实表现好;不怕吃苦，意志坚强，志愿献身军队飞行事业。考生家庭成员及关系密切的亲属，拥护党的路线、方针、政策，历史清楚，无重大问题。本人自愿报考，态度坚定，家长支持。</p>
                <p><span>身体条件</span>：身高165—185厘米(赤脚测量)，体型匀称;体重在52千克以上，未满18周岁体重在50千克以上(偏瘦或过胖者不宜上站)；无纹身。平静时血压值不超过138/88mmHg，不低于100/60 mmHg，脉压差不低于30 mmHg，脉搏56—100次/分钟。用C字视力表检查，双眼裸眼远视力不低于0.8(相当于E字表1.0)，无色盲、色弱，未做过视力矫正术(如准分子手术、戴OK镜等)。听力、嗅觉正常；无口吃。</p>
                <p><span>文化条件</span>：预计高考成绩能够达到本省一本线左右，外语限考英语，数学、英语单科成绩不能过低，综合素质特别优秀的可加分录取。高考成绩优异者可推荐至北京大学、清华大学和北京航空航天大学进行军地“双学籍”联合培养。</p>
                <p><span>心理品质条件</span>：学习能力：求知欲强，学习刻苦，自学能力、记忆能力和理解能力强。意志品质：遵守纪律，自制力强，办事果断，独立完成任务能力强。性格特点：性格开朗，乐观向上，情绪稳定，团队意识强。动作反应：反应敏捷，动作灵活，身体协调，模仿能力强。</p>
            </div>
        </div>
        <div class="main">
            <h6 class="main_title">招收对象是谁？</h6>
            <div class="main_box">
                <p>高中毕业生：年龄16-19岁。</p>
            </div>
        </div>
        <div class="main">
            <h6 class="main_title">培养模式</h6>
            <div class="main_box">
                <p class="title">“3+2”模式：</p>
                <p class="detail">海军飞行学员目前为5年全日制教育，按“3+2”模式培养，即前3年在山东省烟台市海军航空工程学院(“双学籍”学员在北京大学、清华大学和北京航空航天大学)完成大学基础课程、航空理论和军政基础等教育训练内容，第4、5学年在辽宁省葫芦岛市海军航空兵学院完成初教机、高教机飞行训练。</p>
                <p class="title">联合培养（双学籍）：</p>
                <p class="detail">海军从每年招收录取的普通高中毕业生飞行学员中，选拔部分高考成绩优异、体验飞行合格、符合普通高等学校录取要求的学员，送入相关地方普通高等学校学习，同时注册军队院校、地方普通高等学校学籍（简称“双学籍”）</p>
            </div>
        </div>
        <div class="main application_process">
            <h6 class="main_title">报考流程（以简章为主）</h6>
            <ul class="lis_box">
                <li>
                    <p>自愿报名</p>
                    <p>当年9月-10月</p>
                </li>
                <li>
                    <p>初检预选</p>
                    <p>当年9月-12月</p>
                </li>
                <li>
                    <p>全面检查</p>
                    <p>次年1月-5月</p>
                </li>
                <li>
                    <p>定选录取</p>
                    <p>6月-7月</p>
                </li>
            </ul>
        </div>

        <div class="main">
            <h6 class="main_title">就业情况</h6>
            <div class="main_box">
                <p>飞行学员入校3个月后取得学籍和军籍，父母享受军属待遇。在校期间费用全免且实行供给制，统一发放被装和津贴费，享受水果费和较高的伙食标准。</p>
                <p>第4学年结束后，取得本科学历及工科学位，享受副连职军官待遇;完成高教机训练科目的颁发任职培训合格证书，授予第二学位(军事学学位)，职务可提前晋升为正连职。</p>
                <p>飞行学员毕业后，统一分配到海军航空兵部队服役，可逐级晋升至师职，优秀者将成长为共和国将军。</p>
                <p>飞行员享受飞行专业津贴，每年安排带薪休假和疗养，婚后配偶即可随军，优先安排工作和分配住房，符合条件的可特招入伍;子女参加高考，凡符合海军院校招生条件的优先录取。</p>
                <p>海军飞行部队大多地处沿海一线，生活便利、条件优越，能够为个人和家庭提供良好保障。作为国际性军种，海军飞行员有较多机会参加海外出访、远洋护航、联合军演，在国际舞台上展现中国海军的光辉形象。</p>
            </div>   
        </div>
        <div class="remind main">
            <h6 class="main_title">特别提醒</h6>
            <div class="main_box">
                <p><span>1</span>考生须将海军航空兵学院(航空飞行与指挥专业)作为高考第一志愿填报，海军航空兵学院属最提前批次录取的一本院校，不影响学生报考其他院校。</p>
                <p><span>2</span>2017年，海军计划在北京、辽宁、河北、山东、河南、安徽、江苏、湖北七省一市53个地区高中毕业生及军队学历教育院校应届本科毕业学员中招收飞行学员。</p>
            </div>   
        </div>
        <div class="universities main">
            <h6 class="main_title">选拔中心联系方式</h6>
            <div class="main_box">
                <p>地址：北京市丰台区东大街5号</p>
                <p>邮编：100071</p>
                <p>电话：010-66959261 66959262</p>
                <p>传真：010-63817818</p>
                <p>电子邮箱：hjzfb@sohu.com</p>
                <p>英文网址：www.hjzf.mil.cn</p>
                <p>中文网址：http://xn--i7q733b03h5j9b.xn--fiqs8s/ 海军招飞.中国 / http://xn--i7q733b03h5j9b.cn/ 海军招飞.cn</p>
            </div> 
        </div>
    </div>
</template>
<script>
export default {
    // components: { Yuanxiaoku },
    // props: [ 'message' ],
     data() {
        return {
            universities: [ 
            ]
        }
    },
    methods: {
        goUniversity(id) {
            var id = id;
            let {href}=this.$router.resolve({
                path: '/yuanxiaoxiangqing',
                name: 'yuanxiaoxiangqing',
                query: {
                    id: id,
                }
            })
            window.open(href, '_blank');
        }
    },
    created() {
    }
}
</script>
<style type="text/css" lang='less' scoped>
    @import "../study_way_common.less";
    .sea_force {
        .universities {
            
        }
    }
</style>